document.querySelectorAll(".tooltip").forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.classList.add("tooltip-visible");
  });

  item.addEventListener("mouseout", () => {
    item.classList.remove("tooltip-visible");
  });
});
